export const ismatch = (us) => (ps) => {
    if (us.length === ps.length) {
        const result = {};
        for (let i = 0; i < ps.length; ++i) {
            if (ps[i].startsWith('$')) {
                result[ps[i].substring(1)] = us[i];
                continue;
            }
            else if (ps[i] === us[i]) {
                continue; // static - ignore
            }
            return null;
        }
        return result;
    }
    return null;
};
// Carries the page a link was followed from across a full document load.
export const ORIGIN_PARAM = 'from';
export const isOriginState = (x) => typeof x === 'object' && x !== null && 'from' in x && typeof x.from === 'string';
export const isCrossOrigin = (url) => new URL(url, window.location.origin).origin !== window.location.origin;
export const carryOrigin = (url) => {
    const target = new URL(url, window.location.origin);
    target.searchParams.set(ORIGIN_PARAM, window.location.href);
    return target.toString();
};
export const routePath = (path) => path.length === 0 ? '/' : `/${path.join('/')}`;
export const ROUTE_CHANGE_EVENT = 'rad:route-change';
export const dispatchRouteChange = () => {
    window.dispatchEvent(new Event(ROUTE_CHANGE_EVENT));
};
export const stripQuery = (x) => x.split('?')[0];
export const stripQueryAndHash = (x) => stripQuery(x).split('#')[0];
export const trimTrailingEmpty = (xs) => xs[xs.length - 1] === '' ? xs.slice(0, -1) : xs;
export const normalizePath = (path) => {
    const trimmed = stripQueryAndHash(path).replace(/\/+$/, '');
    return trimmed === '' ? '/' : trimmed;
};
export const isAppPath = (path, basename) => {
    if (!basename)
        return true;
    const normalized = normalizePath(path);
    const normalizedBase = normalizePath(basename);
    return normalized === normalizedBase || normalized.startsWith(`${normalizedBase}/`);
};
export const navigationTarget = (target) => {
    if (target.startsWith('#')) {
        return { 'kind': 'hash', 'value': target };
    }
    if (!target.startsWith('/') && !target.startsWith(window.location.origin)) {
        return { 'kind': 'document', 'value': target };
    }
    const url = new URL(target, window.location.origin);
    if (url.origin !== window.location.origin) {
        return { 'kind': 'document', 'value': target };
    }
    return { 'kind': 'url', 'url': url, 'local': `${url.pathname}${url.search}${url.hash}` };
};
const getHashRoute = () => window.location.hash.startsWith('#/') ? window.location.hash : null;
const routeSearch = () => {
    const hash = getHashRoute();
    if (hash) {
        const qIndex = hash.indexOf('?');
        return qIndex === -1 ? '' : hash.substring(qIndex);
    }
    return window.location.search;
};
const nonRouteHash = () => {
    const hash = window.location.hash;
    return hash && !hash.startsWith('#/') ? hash : '';
};
export const getRouteParams = () => new URLSearchParams(routeSearch());
export const getRouteParam = (key) => getRouteParams().get(key);
export const makeRouteParamUrl = (key, value) => {
    const params = getRouteParams();
    params.set(key, value);
    const search = params.toString();
    const query = search ? `?${search}` : '';
    const hash = getHashRoute();
    if (hash) {
        const qIndex = hash.indexOf('?');
        const path = qIndex === -1 ? hash : hash.substring(0, qIndex);
        return `${window.location.pathname}${window.location.search}${path}${query}`;
    }
    return `${window.location.pathname}${query}${nonRouteHash()}`;
};
export const setRouteParam = (key, value) => {
    window.history.replaceState(window.history.state, '', makeRouteParamUrl(key, value));
    dispatchRouteChange();
};
